import { Features } from 'generated/featureDefinitions'

import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'

import { Filters } from 'modules/ats/pages/InsightsPage/MetricsFiltersProvider'

export interface ICandidatesBySource {
  data: { source: string; totalCandidates: number; moved: string; hired: number }[]
}

export const useAtsInsightsFeatureAvailability = () => {
  const { loading, featureAvailability } = useFeatureAvailability(Features.ats_insights)
  const hasInsightsAvailable = featureAvailability.available

  return { loading, hasInsightsAvailable }
}

interface IExportUrlParams {
  atsCompanyId: number
  filters: Filters
}

export const useExportUrlParams = ({ atsCompanyId, filters }: IExportUrlParams) => {
  const exportUrlParams = [
    ['ats_company_id', atsCompanyId.toString()],
    ['start_date_range', filters.startDateRange],
    ['end_date_range', filters.endDateRange],
  ]

  filters.atsJobPostingIds.forEach((jobId) =>
    exportUrlParams.push(['ats_job_posting_ids[]', jobId.toString()])
  )
  filters.teamIds.forEach((teamId) => exportUrlParams.push(['ats_team_ids[]', teamId.toString()]))

  return { exportUrlParams }
}
